import Vue from "vue";
import Vuex from "vuex";

// import axios from "axios";
// import AppConfig from "../../../AppConfig";
// import NODE_ENV from "../../../env";

// const baseURL = AppConfig[NODE_ENV]["apiGatewayBookings"];

Vue.use(Vuex);

export default {
  state: {
    shipConsolidationID: null,
    consolidations : [],
  },
  getters: {
    getShipConsolidationID: (state) => {
      return state.shipConsolidationID;
    },
  },
  mutations: {

    SHIP_CONSOLIDATION_ID(state, payload) {
      state.shipConsolidationID = payload;
    },
    SET_CONSOLIDATIONS(state, payload){
       state.consolidations = payload
    }
  },
  actions: {
    setShipConsolidationID({ commit }, payload) {
      // console.log(payload);
      commit("SHIP_CONSOLIDATION_ID", payload);
    },
    setConsolidations({ commit }, payload){
      commit("SET_CONSOLIDATIONS", payload)
    }
  },
};
